<template>
  <v-dialog
    :value="value"
    transition="dialog-top-transition"
    max-width="600px"
    persistent
  >
    <v-card class="mt-0 pt-0">
      <user-boss-list-table v-model="selectedUsers" :mode="'compact'" @onCloseWindow="onCloseDialog"/>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="onCloseDialog" color="primary"> ОК </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import UserBossListTable from '@/components/modules/org/structure/staff/components/userBossListTable'
export default {
  name: 'userSelectBossDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: { UserBossListTable },
  data () {
    return {
    }
  },
  watch: {},
  computed: {
    selectedUsers: {
      get: function () {
        return this.user.BOSSLIST
      },
      set: function (val) {
        this.$emit('onSelectedUser', val)
      }
    }
  },
  methods: {
    onCloseDialog () {
      this.$emit('input', false)
    }
  },
  mounted () {
    console.log('userSelectBossDialog mounted with user ', this.user)
  }
}
</script>

<style scoped>

</style>
